import { AxiosInstance, AxiosResponse } from 'axios'
import { ApiKeyCreated, ApiKeyMetadata, PatchApiKey, PostApiKey } from '../types/api.types'
import apiClient from './api-client'

export class KeysAPI {
  private client: AxiosInstance

  /** The response payload sent when the API key was rejected by the provider. */
  private static readonly PROVIDER_REJECTED_RESPONSE_PAYLOAD = 'API key was rejected by provider.'

  constructor(axiosClient: AxiosInstance) {
    this.client = axiosClient
  }

  async getApiKeys() {
    try {
      const { data } = await this.client.get<ApiKeyMetadata[]>('/v1/keys')
      return data
    } catch (error) {
      console.error('Failed to fetch API keys', error)
      throw error
    }
  }

  async createApiKey(body: PostApiKey) {
    try {
      const { data } = await this.client.post<ApiKeyCreated>('/v1/keys', body)
      return data
    } catch (error) {
      console.error(`Failed to post API key`, error)
      throw error
    }
  }

  /**
   * Returns true if the response indicates that the API key was rejected by the provider.
   *
   * This can only happen for responses of {@link createApiKey}.
   */
  isProviderRejectedResponse(response: AxiosResponse): boolean {
    return response.status === 400 && response.data === KeysAPI.PROVIDER_REJECTED_RESPONSE_PAYLOAD
  }

  async updateApiKey(id: string, body: PatchApiKey) {
    try {
      const { data } = await this.client.patch<ApiKeyMetadata>(`/v1/keys/${id}`, body)
      return data
    } catch (error) {
      console.error(`Failed to patch API key ${id}`, error)
      throw error
    }
  }

  async deleteApiKey(id: string) {
    try {
      await this.client.delete(`/v1/keys/${id}`)
    } catch (error) {
      console.error(`Failed to delete API key ${id}`, error)
      throw error
    }
  }
}

export default new KeysAPI(apiClient)
